module.exports = __webpack_public_path__ + "img/ZWF_Lunch_Sunday.1184c0a4.jpg";